import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import PublicHeader from "../components/Layout/PublicHeader";
import Footer from "../components/Layout/Footer";
import "../styles/about.css";

const AboutPage = () => {
  const teamMembers = [
    {
      name: "Aurélien",
      role: "CEO",
      description: "10 ans d'expérience dans le BTP, passionné par l'efficacité opérationnelle",
    },
    {
      name: "Julien",
      role: "Opérations",
      description: "Expert en transport et logistique, gère nos équipes de livraison",
    },
    {
      name: "Sandra",
      role: "Directrice Financière",
      description: "Assure les décisions stratégiques financières et la conformité réglementaire",
    },
     {
      name: "Houssem",
      role: "Ful stack developer",
      description: "Expert en développement d'applications mobiles et web conviviales",
    },
    {
      name: "Jean-Baptiste",
      role: "Product Manager",
      description: "Expert en développement produit et UX",
    },
  ];

  return (
    <div className="about-page">
      <PublicHeader />

      {/* Hero Section */}
      <section className="about-hero-section">
        <Container>
          <Row className="text-center">
            <Col>
              <h1 className="display-4 fw-bold mb-3">À propos de Marion</h1>
              <p className="lead text-muted">
                Tu travailles, nous livrons
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Mission Section */}
      <section className="about-mission-section py-5">
        <Container>
          <Row className="align-items-center">
            <Col lg={6} className="mb-4 mb-lg-0">
              <h2 className="mb-4">Notre mission</h2>
              <p className="lead">
                Marion est né d'un constat simple : les artisans et entrepreneurs
                perdent un temps précieux à se déplacer chez les fournisseurs de
                matériaux.
              </p>
              <p>
                Nous avons créé Marion pour résoudre ce problème persistant. Notre
                mission est de livrer les matériaux directement sur les chantiers,
                permettant aux artisans de se concentrer sur leur cœur de métier.
              </p>
              <p>
                Inspirés par Arion, le cheval ailé mythique symbolisant la vitesse,
                la puissance et l'efficacité, nous apportons ces mêmes qualités à
                la livraison de matériaux.
              </p>
            </Col>
            <Col lg={6}>
              <div className="mission-values">
                <div className="value-card mb-3">
                  <div className="value-icon">
                    <i className="fas fa-bolt"></i>
                  </div>
                  <div className="value-content">
                    <h5>Rapidité</h5>
                    <p>
                      Livraison rapide pour ne pas ralentir tes chantiers
                    </p>
                  </div>
                </div>
                <div className="value-card mb-3">
                  <div className="value-icon">
                    <i className="fas fa-rocket"></i>
                  </div>
                  <div className="value-content">
                    <h5>Mobilité</h5>
                    <p>
                      Service mobile accessible partout, quand tu en as besoin
                    </p>
                  </div>
                </div>
                <div className="value-card">
                  <div className="value-icon">
                    <i className="fas fa-cogs"></i>
                  </div>
                  <div className="value-content">
                    <h5>Efficacité</h5>
                    <p>
                      Maîtrise des processus pour optimiser ton temps de travail
                    </p>
                  </div>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Story Section */}
      <section className="about-story-section py-5 bg-light">
        <Container>
          <Row>
            <Col lg={8} className="mx-auto text-center">
              <h2 className="mb-4">L'histoire de Marion</h2>
              <p className="lead mb-4">
                Le nom "Marion" tire son origine d'Arion, le cheval ailé mythique
                symbole de vitesse et de puissance.
              </p>
              <p>
                Le "M" de Marion symbolise à la fois les <strong>Matériaux</strong>,
                le <strong>Mouvement</strong> et la <strong>Modernisation</strong> des
                processus de livraison dans le secteur du BTP.
              </p>
              <p>
                Notre vision est simple : révolutionner la manière dont les
                professionnels du bâtiment accèdent à leurs matériaux. En un clic
                sur notre application mobile, tu peux commander et recevoir tes
                matériaux directement sur ton chantier.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      {/* Team Section */}
      <section className="about-team-section py-5">
        <Container>
          <Row className="mb-5">
            <Col className="text-center">
              <h2 className="mb-3">L'équipe fondatrice</h2>
              <p className="lead text-muted">
                Quatre experts passionnés unis pour révolutionner la livraison de
                matériaux
              </p>
            </Col>
          </Row>
          <Row>
            {teamMembers.map((member, index) => (
              <Col md={6} lg={3} key={index} className="mb-4">
                <Card className="team-card h-100 border-0 shadow-sm">
                  <Card.Body className="text-center">
                    <div className="team-avatar mb-3">
                      <i className="fas fa-user-circle fa-4x text-primary"></i>
                    </div>
                    <h5 className="mb-1">{member.name}</h5>
                    <p className="text-primary small mb-3">{member.role}</p>
                    <p className="small text-muted">{member.description}</p>
                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* Value Proposition Section */}
      <section className="about-value-section py-5 bg-primary text-white">
        <Container>
          <Row className="text-center">
            <Col lg={8} className="mx-auto">
              <h2 className="mb-4">Tu travailles, nous livrons</h2>
              <p className="lead mb-4">
                Marion te permet de te concentrer sur ton travail pendant que nous
                nous occupons de la livraison de tes matériaux.
              </p>
              <p className="mb-4">
                Commande en ligne sur marion-livraison.com et suis ta livraison en temps réel.
              </p>
            </Col>
          </Row>
        </Container>
      </section>

      <Footer />
    </div>
  );
};

export default AboutPage;
